
<script setup>

  import AudioPlayer from '../components/audio-player.vue';

  import audio from '../audio/audrey-*.mp3';

  import track from '../audio/audrey-*.vtt';

  const players = [ {

    id: 1,

    title: 'Visiting Lewis Mountain Part 1'

  }, {

    id: 2,

    title: 'Visiting Lewis Mountain Part 2'

  }, {

    id: 3,

    title: 'Summertime Job'

  }, {

    id: 4,

    title: 'A Typical Day'

  } ].map( obj => ( { ...obj, audio: audio[ obj.id ], track: track[ obj.id ] } ) );

</script>

<template>

  <p>Waitress and Cook</p>

  <div v-for="{ audio, track, title } in players" class="mt-6" >

    <h4 class="font-bold">{{ title }}</h4>

    <AudioPlayer class="mt-4" :src="audio" :track="track" />

  </div>

  <div class="mt-8 text-xs italic">

    Source: Interview with Audrey Tutt Smith, August 3, 2007.

  </div>

</template>
